exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mx-auto[data-v-53ade19e]{margin-left:auto;margin-right:auto}.primary-button[data-v-53ade19e]{margin:1.75rem .25rem .25rem;display:block;cursor:pointer;border-radius:.25rem;border-width:2px;--tw-border-opacity:1;border-color:rgba(148,0,4,var(--tw-border-opacity));--tw-bg-opacity:1;background-color:rgba(148,0,4,var(--tw-bg-opacity))}", ""]);

// exports
